import React from "react";
import {useRef, createContext,useState,useEffect  } from 'react';
import "./CreateForm.css";
import { post } from "../../../../../Script/Session.js";
import { Token } from "../../../../../Script/Session.js";
import { useNavigate } from 'react-router-dom';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Stylebutton from "../../../../../components/buttons/stylebutton/Stylebutton.jsx";
const CreateForm = ({setmask}) => {
    const [data, setdata] = useState("{}");
    const [va, setva] = useState("{}");
    const navigate = useNavigate();
    const [n, setname] = useState("");
    function submit(){
        let name = n;
        if (name == ""){
            alert("falscher Funktionsname");
            return;
        }
        let body = {};
        body.token = Token.get();
        body.name = name;
        body.action = "create";
        body.permissions = data.values
        .filter(item => document.getElementById(`create-group-${item.int}`).checked)
        .map(item => item.int);
        body.points = po;
        body.description = va;
        console.log(body);
        let response = post(body, "/editGroups");
        if (response == null){
            alert("Fehler beim Anlegen der Gruppe");
            return;
        }
        if (response == "ExistingName"){
            alert("Dieser Gruppename existiert bereits!");
            return;
        }
        if (response == "LOGOUT"){
            navigate("/");
            return;
        }
        let json = JSON.parse(response);
        if (json.status == "OK"){
            alert("Gruppe erfolgreich angelegt");
            window.location.reload();
        }
    }


    const [loading, setLoading] = useState(true);
    const [filteritems, setfiltereditems] = useState("{}");
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            try {
                const body = {
                    token: Token.get()
                };

                const response = await post(body, "/getpermissions");

                if (!response) {
                    alert("GruppenVerwaltung hat einen Fehler!");
                    return;
                }

                if (response === "LOGOUT") {
                    navigate("/");
                    return;
                }

                const json = JSON.parse(response);
                setdata(json);
                console.log(response);
                setfiltereditems(json.values);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        // Delay fetch slightly to avoid blocking render
        setTimeout(() => {
            fetchData();
        }, 0); // Immediate but non-blocking
    }, [navigate]);
    function search(event){
        event.preventDefault();
        console.log("Searching...");
        let prompt = document.getElementById("bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb").value;
        if (prompt == ""){
            setfiltereditems(data.values);
            return;
        }
        setfiltereditems(
            data.values.filter(item => 
                item.desc && item.desc.toLowerCase().includes(prompt.toLowerCase()) // Ensure desc is a string
            )
        );

    }

      const [po, setpo] = useState(0);
      const [d, setd] = useState("");
      const handleChange = (event, id) => {
        const { checked } = event.target;
        console.log(`Checkbox ${id} clicked, new value: ${checked}`);
        setfiltereditems(
            filteritems.map((item) => {
                console.log("Before:", item); // Log the item before modification
                const updatedItem = item.int === id ? { ...item, checked: checked.toString() } : item;
                console.log("After:", updatedItem); // Log the updated item
                return updatedItem;
            })
        );
      };

    return(
        <div style={{position: "absolute", left: "56%", top: "50%",boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',transform: "translate(-50%, -50%)",
         backgroundColor: "white", height: "75%", width: "80%",
         flexDirection:"column", justifyContent:  "center", display: "flex"}}>
            <div style={{height: "10%", width: "100%", backgroundColor: "#2b3142", alignItems: "center", justifyContent: "center", display: "flex",fontSize: "20px"}}>
                <p style={{color: "white"}}>Neue Funktion</p>
            </div>
            <div style={{height: "5%", width: "100%", alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "row", color: "gray"}}>
                    <p>Funktionsbezeichnung:</p>
                    <div style={{width: "5px", width: "50px", display: "flex"}}/>
                    <input  onChange={(e) => setname(e.target.value)}></input>

            </div>
            <div style={{height: "5%", width: "100%", alignItems: "center", justifyContent: "center", display: "flex", flexDirection: "row", color: "gray"}}>
                    <p>Zu Vergebene Punkte:</p>
                    <div style={{width: "5px", width: "50px", display: "flex"}}/>
                    <input type="number" value={po} onChange={(e) => setpo(e.target.value)}></input>

            </div>
            <div style={{display: "flex", height: "80%", width: "100%", flexDirection: "row", color: "black"}}>
                <div style={{display: "flex", height: "100%", width: "70%", justifyContent: "flex-end"}}>
                <ReactQuill c style={{height: "90%", width: "98%", color:"black"}} id="group-name-input-text-edit" placeholder="Beschreibung" value={va} onChange={(content) => setva(content)}  required/>
                </div>
                <div style={{display: "flex", height: "95%", width: "30%", flexDirection: "column"}}>
                <form
                    style={{
                        display: "flex",
                        marginLeft: "1%",
                        width: "98%",
                        backgroundColor: "transparent",
                        boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                        marginBottom: "3px"
                    }}
                    onSubmit={search}
                    >
                    <div
                        style={{
                        display: "flex",
                        flexGrow: 1,
                        alignItems: "center",
                        width: "100%"
                        }}
                        className="group"
                    >
                        <input
                        onChange={e => {
                            if (!e.target.value) {
                            setfiltereditems(data.values);
                            }
                        }}
                        placeholder="Suchen"
                        id="bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb"
                        type="search"
                        className="input"
                        style={{
                            width: "100%",
                            padding: "8px",
                            fontSize: "14px",
                            border: "none",
                            outline: "none"
                        }}
                        />
                    </div>
                    </form>
                    <ul style={{width: "100%", height: "90%", overflowY: "auto", marginLeft: "-9%"}}>
                    {loading ? (
                        <p>Loading...</p> // Show loading text until data is fetched
                    ) : filteritems.length === 0 ? (
                        <p>Nichts Gefunden</p> // Show "Nothing found" when no items match the filter
                    ) : (
                        filteritems.map((item, index) => (
                            <li
                            key={item.int}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "12px",
                                padding: "12px 15px",
                                borderRadius: "8px",
                                backgroundColor: "#ffffff",
                                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                transition: "background-color 0.3s ease, box-shadow 0.3s ease",
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = "#efefef";
                                e.currentTarget.style.boxShadow = "0px 2px 6px rgba(0, 0, 0, 0.2)";
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "#ffffff";
                                e.currentTarget.style.boxShadow = "0px 2px 4px rgba(0, 0, 0, 0.1)";
                            }}
                            >
                            <input
                                onChange={(e) => handleChange(e, item.int)}
                                type="checkbox"
                                id={`create-group-${item.int}`}
                                name={item.name}
                                value={item.id}
                                checked={item.checked === "true"}
                                style={{ width: "20px", height: "20px" }}
                            />
                            <label
                                htmlFor={`create-group-${item.int}`}
                                style={{ fontSize: "14px", color: "#333", display: "block" }}
                            >
                                {item.desc}
                            </label>
                            </li>
                        ))
                    )}
                    </ul>
                </div>

            </div>
            <div style={{width: "100%", height: "5%", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "3%", flexDirection: "row", justifyContent: "space-evenly"}}>
                <Stylebutton buttonText={"Abbrechen"} click={() => setmask(false)}></Stylebutton>
                <div onClick={submit}><Stylebutton buttonText={"Speichern"}></Stylebutton></div>
            </div>
        </div>


    );

}
export default CreateForm;